module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG0007-91692d633aaaf9d1f36a2227e837c95b.png";